<template>
  <div>
    <v-img
      :src="require('@/assets/images/mita-logo-2.svg')"
      class="header-logo"
      contain
      height="100%"
      v-if="mode === 'default'"
    />
    <v-img
      :src="require('@/assets/images/mita-logo-dark-2.svg')"
      class="header-logo"
      contain
      height="100%"
      v-if="mode === 'dark'"
    />
  </div>
</template>

<script>
export default {
  name: "LogoImage",
  props: {
    mode: {
      type: String,
      default: "default",
    },
  },
};
</script>
